import type { UserInfoCustomer, UserInfoOrganisation } from "../api/userInfo";

export type EnterpriseCustomer = Extract<UserInfoCustomer, { customerKind: "enterprise" }>;

export const isEnterpriseCustomerScope = ({
  currentCustomer,
  currentOrganisation,
}: {
  currentCustomer: UserInfoCustomer;
  currentOrganisation: UserInfoOrganisation;
}) => currentCustomer.customerKind === "enterprise" && currentCustomer.id === currentOrganisation.id;

export const accessibleOrganisations = (customer: EnterpriseCustomer, language: string) => [
  ...(customer.permissions.length > 0 ? [customer] : []),
  ...[...customer.organisations].sort((a, z) => a.name.localeCompare(z.name, language)),
];

export const customerOrganisationNames = (customer: UserInfoCustomer) =>
  customer.customerKind === "enterprise"
    ? customer.organisations.map(({ id, name }) => ({ id, organizationName: name }))
    : undefined;

export const customerOrganisation = (customer: UserInfoCustomer, organisationId: string | undefined) =>
  customer.customerKind === "enterprise" ? customer.organisations.find(({ id }) => id === organisationId) : undefined;
